export const COACH_STEPS = {
    PLAN_CREATED: 'planCreated',
    PLAN_SHARED: 'planShared',
    FIRST_TRAINING_CREATED: 'firstTrainingCreated',
};

export const COACH_DEFAULT_STATE = {
    [COACH_STEPS.PLAN_CREATED]: false,
    [COACH_STEPS.PLAN_SHARED]: false,
    [COACH_STEPS.FIRST_TRAINING_CREATED]: false,
};